import { render } from "./Footer.vue?vue&type=template&id=1de405dc&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1de405dc&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de405dc"]])

export default __exports__